import React from 'react';
import PropTypes from 'prop-types';

const DepoimentoCard = ({ 
  depoimento, 
  estrelas, 
  ativo, 
  onClick 
}) => {
  return (
    <div 
      className={`depoimento-card ${ativo ? 'selected' : ''}`}
      onClick={onClick}
    >
      <img
        src={depoimento.imagem}
        alt={depoimento.nome}
        className="depoimento-image"
        style={{
          filter: ativo ? 'none' : 'grayscale(100%)',
          opacity: ativo ? 1 : 0.7
        }}
      />
      <div className="depoimento-content">
        <div className="estrela-container">
          {estrelas.map((estrelaImg, i) => (
            <img key={i} src={estrelaImg} alt="estrela" className="estrela" />
          ))}
        </div>
        <p className="nome">{depoimento.nome}</p>
        <p className="cargo">{depoimento.cargo}</p>
      </div>
    </div>
  );
};

DepoimentoCard.propTypes = {
  depoimento: PropTypes.shape({
    imagem: PropTypes.string.isRequired,
    nome: PropTypes.string.isRequired,
    cargo: PropTypes.string.isRequired,
    texto: PropTypes.string.isRequired
  }).isRequired,
  estrelas: PropTypes.arrayOf(PropTypes.string).isRequired,
  ativo: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default React.memo(DepoimentoCard);